import React, { Fragment, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { parse } from 'date-fns';
import { ReactComponent as ClockIcon } from 'assets/images/activity/clock.svg';
import { Separator } from 'components/ui/separator';
import { getSearchParams } from 'modules/home/utils/helpers';
import AvailabilityEmptyList from './emptyList';
import EventAvatar from '../../../modules/home/pages/homePage/EmojiAvatar';
import { IEvent } from 'types/event';

type UserActivityProps = {
  activities: IEvent[];
};

const UserActivities: React.FC<UserActivityProps> = ({ activities }) => {
  const navigate = useNavigate();
  // get search params
  const location = useLocation();
  const searchParams = getSearchParams(location.search ?? '');
  const focusToEventId = searchParams?.ref;
  const focusEventDate = searchParams?.date;
  const formattedFocusEventDate = focusEventDate
    ? parse(focusEventDate, 'yyyy-MM-dd', new Date())
    : null;

  // initial data loaded flag
  const initialDataLoadedRef = useRef(false);

  // initial data load handler
  const handleInitialDataLoad = () => {
    focusToEventId &&
      setTimeout(() => {
        const element = document.getElementById(focusToEventId);
        element &&
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 50);
  };

  // initial data load effect
  useEffect(() => {
    if (activities && !initialDataLoadedRef.current) {
      handleInitialDataLoad();
      initialDataLoadedRef.current = true;
    }
  }, [activities]);

  return (
    <div className="mt-3">
      <p className="py-1 text-xl font-bold uppercase font-manrope">
        Friend Activity
      </p>

      <div className="my-2.5 flex gap-2.5 flex-col">
        {activities?.length === 0 ? (
          <AvailabilityEmptyList
            icon={<ClockIcon />}
            text="You have no activities to show here"
          />
        ) : (
          activities?.map((activity: any, index: number) => (
            <Fragment key={activity._id}>
              <div
                className="flex gap-2.5 items-center"
                onClick={() =>
                  navigate(
                    `/lets-meet/receive/${activity?.eventId}?origin=activities`,
                  )
                }
                id={activity.eventId}
              >
                <div className="flex shrink-0">
                  <EventAvatar
                    size="medium-large"
                    image={activity?.icon}
                    fullName={activity?.organizer}
                  />
                  {/* <EventIcon icon={activity.icon} size="medium"/>*/}
                </div>
                <div>
                  {/* TODO: update this  */}
                  <div className="text-sm font-bold">{activity?.organizer}</div>
                  <div className="text-xs">{`is going to ${activity.activity}`}</div>
                </div>
              </div>

              {index !== activities.length - 1 && (
                <Separator className="bg-white/20" />
              )}
            </Fragment>
          ))
        )}
      </div>
    </div>
  );
};

export default UserActivities;
